
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');


window.Vue = require('vue');
import Vuex from 'vuex'
Vue.use(Vuex)
require('slick-carousel');
require('./includes/ui/slider');
require('./includes/cookies');
require('./includes/googleanalytics');
require('./includes/facebook');
require('./includes/googletagmanager');
require('./includes/storage')
require('imagesloaded');
require('imagesloaded').makeJQueryPlugin( $ );


/* ---------- SITE OBJECT ---------- */

var SITE = {
    common: {
        init: function() {
            console.log('common');
            require('./includes/utils')
            require('./components/heading')
            require('./components/lazyImg')
            require('./components/plan')
            require('./components/ctaOrders')
            require('./components/ctaLink')
            require('./components/modalCallNow')
        }
    },

    home: {
        init: function() {
            console.log('home');
            require('./components/utm_cookies')
            require('./components/coverage')
            require('./pages/home/index')
        }
    },

    "iframe": {
        init: function() {
            console.log('iframe');
            require('./components/utm_cookies')
            require('./components/coverage')
            require('./pages/home/index')
        }
    },

    company: {
        init: function() {

        },
        index: function () {
            // TODO Refactoritzar landings.empreses.index a company.index
            require('./pages/landings/empreses/index');
        },
        fix: function () {
            require('./pages/company/init');
        },
        cell: function () {
            require('./pages/company/init');
        },
        net: function () {
            require('./pages/company/init');
        },
    },

    careers: {
        index: function() {
            require('./pages/careers/index');
        }
    },

    mataro: {
        index: function() {
            require('./pages/landings/mataro/index');
        }
    },

    orders: {
        show: function() {
            require('./components/utm_cookies')
            require('./pages/orders/show');
        }
    },

    faq: {
        index: function() {
            require('./pages/faq/index');
        }
    },

    services: {
        index: function() {
            require('./pages/services/index');
        }
    },

    rates: {
        index: function() {
            require('./pages/rates/components/roamingCalc');
        },
        roaming: function() {
            require('./pages/rates/components/roamingFilter');
        },
    },
    energy: {
        index: function() {
            require('./pages/energy/index')
        },
        calculator: function() {
            require('./pages/energy/calculator')
        }
    },
    "contact-us": {
        init: function() {
            require('./pages/contact-us/index');
        }
    },
    privacy: {
      index: function() {
        require('./pages/privacy/index');
      }
    },
    "home-mataro": {
        index: function () {
            require('./pages/landings/home-mataro/index');
        }
    },
    "vic-comerc": {
        index: function () {
            require('./pages/landings/vic-comerc/index');
            require('./components/vicComerc_cookies')
        }
    },
    "girona": {
        index: function () {
            require('./pages/landings/girona/index');
            require('./components/coverage');
            require('./components/girona_cookies')
        }
    },
    "seaOtter": {
        index: function () {
            require('./pages/landings/seaOtter/index');
        }
    },
    "beth": {
        index: function () {
            require('./pages/landings/beth/index');
        }
    },
    "santnarcis": {
        index: function () {
            require('./pages/landings/santnarcis/index');
        }
    },
    "mataro-teatre": {
        index: function () {
            require('./pages/landings/mataro-teatre/index');
        }
    },
    "castanyada": {
        index: function () {
            require('./pages/landings/castanyada/index');
        }
    },
    "landing-energia": {
        index: function () {
            require('./pages/landings/landing-energia/index');
        }
    },
    "empreses-energia": {
        index: function () {
            require('./pages/landings/empreses-energia/index');
        }
    },
    "panera-digital": {
        index: function () {
            require('./pages/landings/panera-digital/index');
		}
	},
    'paneres': {
        index: function() {
            require('./pages/landings/paneres/index');
        }
    },
    'mgm': {
        index: function() {
            require('./pages/landings/mgm/index');
        },
        index2: function() {
            require('./pages/landings/mgm/index');
        }
    },
    'mgv': {
        index: function() {
            require('./pages/landings/mgv/index');
        },
    },
    'FECS': {
        index: function() {
            require('./pages/landings/FECS/index');
        }
    },
    'sortejos': {
        index: function() {
            require('./pages/landings/sortejos/index');
        }
    },
    'migracio-tv': {
        index: function() {
            require('./pages/landings/migracio-tv/index');
        }
    },
    'mesh': {
        index: function() {
            require('./pages/landings/mesh/index');
        }
    },
    'CallMeNow': {
        index: function() {
            require('./pages/landings/CallMeNow/index');
        }
    }
};



/* ---------------------------------------------------------------------------------------------------- */
var UTIL = {
    exec: function(controller, method) {
        var ns = SITE
            method = (method === undefined) ? "init" : method;

        if (controller !== "" && ns[controller] && typeof ns[controller][method] == "function") {
            ns[controller][method]();
        }
    },

    init: function() {
        var body = document.body,
            controller = body.getAttribute("data-controller"),
            method = body.getAttribute("data-method");

        UTIL.exec("common");
        UTIL.exec(controller);
        UTIL.exec(controller, method);
    }
};
/* ---------------------------------------------------------------------------------------------------- */

//Execute scoped JS
$(document).ready(UTIL.init);
